import { surchargesTableHeader } from '../../../../assets/helpers/tables';
import useSurcharges from '../../../../hooks/params/useSurcharges';
import { ActionButton } from '../../../common/Buttons/Buttons';
import { SurchargesTable } from '../../../common/Tables/Tables';
import { itemsPerPageOptions } from '../parametersConstants';
import SurchargesForm from './SurchargesForm';
import SurchargesInfoHeader from './SurchargesInfoHeader';

export default function SurchargesParametersSection() {
  const {
    register,
    handleSubmit,
    reset,
    errors,
    showSurchargesForm,
    setShowSurchargesForm,
    surchargesData,
    setSurchargesData,
    editingSurchargesId,
    setEditingSurchargesId,
    handleSurchargesPageChange,
    handleToggleSSurchargeActive,
    handleEditSSurcharge,
    onSubmit,
    onSurchargesSelectPerPage,
    inactiveSurcharges,
    closeForm,
    getSalesChannelsByName,
    setValue,
    getValues,
    control,
    clearErrorByFiueldName
  } = useSurcharges();
  return (
    <>
      <SurchargesInfoHeader />
      <div className="parameters-page__pills-row" style={{ justifyContent: 'flex-end'}}>
        <ActionButton
          type="button"
          action={() => setShowSurchargesForm((s) => !s)}
          label={'+ Nueva regla'}
        />
      </div>
      <SurchargesTable
        header={surchargesTableHeader}
        data={surchargesData}
        handlePageChange={handleSurchargesPageChange}
        onToggleActive={handleToggleSSurchargeActive}
        onEdit={handleEditSSurcharge}
        itemsPerPageOptions={itemsPerPageOptions}
        onPerPageChange={onSurchargesSelectPerPage}
        inactiveCount={inactiveSurcharges}
      />
    <SurchargesForm
        isOpen={showSurchargesForm}
        onClose={closeForm}
        onSubmit={onSubmit}
        register={register}
        errors={errors}
        editingSurchargesId={editingSurchargesId}
        getSalesChannelsByName={getSalesChannelsByName}
        setValue={setValue}
        getValues={getValues}
        control={control}
        clearErrorByFiueldName={clearErrorByFiueldName}
    />
    </>
  );
}
